import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaTools, FaClock } from 'react-icons/fa';
import './MaintenancePage.css';

const MaintenancePage = () => {
  const { t } = useTranslation();

  return (
    <div className="maint-page">
      <div className="maint-bg">
        <div className="maint-circle maint-circle-1" />
        <div className="maint-circle maint-circle-2" />
        <div className="maint-circle maint-circle-3" />
      </div>

      <div className="maint-card">
        <div className="maint-icon-wrap">
          <div className="maint-icon-ring">
            <FaTools className="maint-icon" />
          </div>
        </div>

        <h1 className="maint-title">{t('maintenance.title', 'Under Maintenance')}</h1>
        <p className="maint-desc">
          {t('maintenance.description', 'We are currently performing scheduled maintenance to improve your experience. Please check back shortly.')}
        </p>

        <div className="maint-divider" />

        <div className="maint-eta">
          <FaClock className="maint-eta-icon" />
          <span>{t('maintenance.eta', 'We\'ll be back soon!')}</span>
        </div>

        <div className="maint-dots">
          <span className="maint-dot" />
          <span className="maint-dot" />
          <span className="maint-dot" />
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
